var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {RegisterWebAsync as InvokeAsync , RegisterWebSync as InvokeSync}

async function RegisterWebAsync(Email,Password,UserName,Domain)
{
    var RegisterPromise = new Promise((resolve, reject) => {
        RegisterWebSync(Email,Password,UserName,Domain,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await RegisterPromise;
}

function RegisterWebSync(Email,Password,UserName,Domain,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/User/RegisterWeb',                
        data  : {
            Email   : Email,
            Password: Password,
            UserName: UserName,
            Domain  : Domain  ,
            AppID   : KEYS.AWS_APPID              
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    }); 
}